// Block registry — defines the reorderable sections of an invitation.
// Hero (portada) and RSVP are ALWAYS first and last respectively.

export const HERO_ID = "hero";
export const RSVP_ID = "rsvp";

export const REORDERABLE_BLOCKS = [
  { id: "date_block",   label: "Reserva la fecha",   bgSupported: true  },
  { id: "countdown",    label: "Cuenta regresiva",   bgSupported: true  },
  { id: "hashtag",      label: "Hashtag",            bgSupported: false },
  { id: "message",      label: "Mensaje personal",   bgSupported: true  },
  { id: "invitation_message", label: "Mensaje de invitación", bgSupported: true },
  { id: "venue",        label: "Ubicación y mapa",   bgSupported: true  },
  { id: "itinerary",    label: "Itinerario",         bgSupported: true  },
  { id: "padrinos",     label: "Padrinos",           bgSupported: true  },
  { id: "dresscode",    label: "Dress code",         bgSupported: true  },
  { id: "extras",       label: "Info extra",         bgSupported: true  },
  { id: "gallery",      label: "Galería",            bgSupported: false },
  { id: "gift",         label: "Regalos",            bgSupported: true  },
  { id: "playlist",     label: "Playlist DJ",        bgSupported: false },
  { id: "guestbook",    label: "Libro de recuerdos", bgSupported: false },
];

export const REORDERABLE_IDS = REORDERABLE_BLOCKS.map((b) => b.id);

export function blockLabel(id) {
  const b = REORDERABLE_BLOCKS.find((x) => x.id === id);
  return b?.label || id;
}

export function blockSupportsBg(id) {
  const b = REORDERABLE_BLOCKS.find((x) => x.id === id);
  return !!b?.bgSupported;
}

// Given the user's saved `block_order`, return a sanitized full ordering (adding any missing default blocks at end)
export function resolveBlockOrder(saved) {
  const valid = (saved || []).filter((id) => REORDERABLE_IDS.includes(id));
  const missing = REORDERABLE_IDS.filter((id) => !valid.includes(id));
  return [...valid, ...missing];
}
